<mat-card>
    <div fxLayout="row wrap">
        <div fxFlex="100">
            <h2 class="text-muted text-center">Reset Password</h2>
            <form [formGroup]="ResetPasswordCustomerForm" (ngSubmit)="onResetPasswordCustomerFormSubmit()">
                <div fxLayout="column" fxLayoutAlign="space-between center">                  
                    
                    <!-- Password Field -->
                    <mat-form-field appearance="outline" class="mt-2" ngClass.lt-sm="w-100" ngClass.gt-xs="w-70">
                        <mat-label>Password</mat-label>
                        <input type="password" matInput placeholder="Password" formControlName="password" required>
                        <!-- Password validation error message -->
                        <mat-error *ngIf="ResetPasswordCustomerForm.get('password')?.hasError('minlength') && ResetPasswordCustomerForm.get('password')?.touched">
                            Password isn't long enough, minimum of 6 characters
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="mt-2" ngClass.lt-sm="w-100" ngClass.gt-xs="w-70">
                        <mat-label>Confirm Password</mat-label>
                        <input type="password" matInput placeholder="Confirm Password" formControlName="cpassword" autocapitalize="off" required>
                        <mat-error *ngIf="ResetPasswordCustomerForm.get('cpassword')?.hasError('minlength') && ResetPasswordCustomerForm.get('cpassword')?.touched">
                            Password isn't long enough, minimum of 6 characters
                        </mat-error>
                        <mat-error *ngIf="ResetPasswordCustomerForm.controls.cpassword.hasError('mismatchedPasswords')">Passwords
                            do not match</mat-error>
                    </mat-form-field>
                    <button mat-raised-button color="primary" class="mat-elevation-z6" type="submit">
                        Reset Password
                    </button>
                </div>
            </form>
        </div>
    </div>
</mat-card>